var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetzauskunft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 274,
    viewBox: "0 0 459 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Netzauskunft"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M237.067 272.976L0.487305 136.312L0.519531 117.007L61.2593 92.3386L259.962 211.724L261.617 254.15L237.067 272.976Z",
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M237.073 273.136L0.484863 136.54V134.001L237.073 270.743V273.136Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M457.03 146.39L237.072 273.137L237.067 254.346V222.431L420.409 114.12L457.014 126.799L457.03 146.39Z",
    fill: "#3C3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.484863 117.057L237.067 254.346L457.015 126.799L220.288 1.96509L0.484863 117.057Z",
    fill: "#65813F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Loch"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    d: "M193.846 59.4165L367.092 154.273V168.73L193.846 74.0174V59.4165Z",
    fill: "#846437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 71",
    d: "M367.124 168.704L193.872 74.1021L111.06 117.922L283.526 217.199L367.124 168.704Z",
    fill: "#A07C42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1",
    d: "M193.94 59.55L111.06 103.571V117.921L193.94 74.0696V59.55Z",
    fill: "#92733E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Schatten"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 420",
    d: "M292.396 116.412L289.714 114.972L289.714 122.024L292.416 123.477L292.396 116.412Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 412",
    d: "M124.649 110.819L142.712 101.082L317.457 197.183L299.101 207.627L124.649 110.819Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 414",
    d: "M177.167 98.0177L185.411 89.7742L345.983 180.728L333.901 187.777L177.167 98.0177Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 418",
    d: "M214.235 99.1436L211.553 97.7031L205.184 100.978L207.94 102.526L214.235 99.1436Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 422",
    d: "M278.44 134.095L275.741 132.638L268.439 136.835L271.298 138.405L278.44 134.095Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 425",
    d: "M255.492 148.892L252.792 147.435L240.493 154.833L243.352 156.403L255.492 148.892Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 419",
    d: "M230.935 82.8393L228.266 81.8228L227.724 88.21L230.426 89.6622L230.935 82.8393Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 413",
    d: "M142.743 101.088L181.444 80.5291L190.047 85.214L162.836 112.094L142.743 101.088Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 415",
    d: "M193.693 82.1371L193.968 69.9219L367.096 164.113V168.706L359.472 173.095L193.693 82.1371Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 424",
    d: "M261.36 99.1046L258.658 97.9875V104.983L261.36 106.435V99.1046Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 416",
    d: "M182.513 71.7242L183.01 69.25L193.941 69.9102L193.879 78.2498L182.513 71.7242Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 426",
    d: "M158.239 84.7764L158.736 82.3022L171.924 85.584L167.965 87.7032L158.239 84.7764Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 427",
    d: "M125.922 101.947L129.098 100.74L139.608 102.755L135.648 104.874L125.922 101.947Z",
    fill: "black",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Strom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M349.108 158.372L345.282 171.035L180.089 81.1075C180.089 81.1075 176.014 78.2357 178.1 73.0182C180.477 67.0724 186.758 69.9521 186.758 69.9521L349.108 158.372Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 81",
    d: "M249.96 102.182L260.371 97.0461C260.371 97.0461 261.36 97.0461 261.36 98.8717C261.36 100.697 260.371 100.697 260.371 100.697L249.96 105.833V102.182Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Abzweigung"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 66",
    cx: 244.884,
    cy: 108.834,
    rx: 7.54435,
    ry: 8.08607,
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 398",
    d: "M247.899 101.439L264.418 110.704L258.041 125.335L241.693 116.159L247.899 101.439Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 67",
    cx: 261.903,
    cy: 118.435,
    rx: 7.29448,
    ry: 8.25855,
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 20",
    rx: 3.5001,
    ry: 5.25014,
    transform: "matrix(-1 0 0 1 251.108 103.583)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 81_2",
    d: "M254.608 103.028H248.967V107.259H254.608V103.028Z",
    fill: "#989898"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M273.418 117.376L269.441 130.031L259.241 124.472C259.241 124.472 255.166 121.6 257.252 116.383C259.629 110.437 265.91 113.317 265.91 113.317L273.418 117.376Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 68",
    cx: 347.475,
    cy: 164.839,
    rx: 5.77004,
    ry: 6.71664,
    fill: "#C3337F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44",
    d: "M214.085 89.0428C217.855 86.3106 221.647 88.8606 224.158 90.3712C222.359 89.5198 219.135 87.3216 216.061 90.5987C212.988 93.8757 212.131 97.2668 213.753 99.4299C207.572 96.8557 212.232 90.3858 214.085 89.0428Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Erdgas"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M324.058 171.456L320.232 184.119L155.039 94.1915C155.039 94.1915 150.963 91.3197 153.049 86.1021C155.426 80.1564 161.707 83.036 161.707 83.036L324.058 171.456Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 81_3",
    d: "M199.032 98.0184L229.947 80.6982C229.947 80.6982 230.935 80.6982 230.935 82.5238C230.935 84.3493 229.947 84.3493 229.947 84.3493L199.032 101.669V98.0184Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Abzweigung_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 66_2",
    cx: 192.129,
    cy: 106.921,
    rx: 7.54435,
    ry: 8.08607,
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 398_2",
    d: "M195.145 99.5264L211.663 108.791L205.286 123.421L188.938 114.246L195.145 99.5264Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 67_2",
    cx: 209.148,
    cy: 116.522,
    rx: 7.29448,
    ry: 8.25855,
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 20_2",
    rx: 3.5001,
    ry: 5.25014,
    transform: "matrix(-1 0 0 1 198.353 101.67)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 81_4",
    d: "M201.854 101.115H196.212V105.346H201.854V101.115Z",
    fill: "#989898"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M220.237 114.895L216.126 127.445L206.03 122.065C206.03 122.065 201.954 119.193 204.04 113.976C206.418 108.03 212.698 110.91 212.698 110.91L220.237 114.895Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 68_2",
    cx: 322.424,
    cy: 177.923,
    rx: 5.77004,
    ry: 6.71664,
    fill: "#7A5299"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 43",
    d: "M278.369 124.016C282.139 121.284 285.931 123.834 288.442 125.345C286.643 124.493 283.419 122.295 280.346 125.572C277.272 128.849 276.415 132.24 278.037 134.404C271.857 131.829 276.516 125.359 278.369 124.016Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Wasser"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M293.405 189.694L289.579 202.358L124.386 112.43C124.386 112.43 120.31 109.558 122.396 104.34C124.773 98.3946 131.054 101.274 131.054 101.274L293.405 189.694Z",
    fill: "#6792FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 81_5",
    d: "M231.019 149.314L291.346 114.076C291.346 114.076 292.334 114.076 292.334 115.902C292.334 117.728 291.346 117.728 291.346 117.728L231.019 152.965V149.314Z",
    fill: "#6792FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Abzweigung_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 66_3",
    cx: 223.474,
    cy: 158.771,
    rx: 7.54435,
    ry: 8.08607,
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 398_3",
    d: "M226.489 151.377L243.008 160.642L236.631 175.272L220.282 166.096L226.489 151.377Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 67_3",
    cx: 240.493,
    cy: 168.372,
    rx: 7.29448,
    ry: 8.25855,
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 20_3",
    rx: 3.5001,
    ry: 5.25014,
    transform: "matrix(-1 0 0 1 229.698 153.52)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 81_6",
    d: "M233.198 152.965H227.557V157.196H233.198V152.965Z",
    fill: "#989898"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M251.705 167.086L247.773 179.581L237.528 174.182C237.528 174.182 233.452 171.31 235.538 166.093C237.915 160.147 244.196 163.027 244.196 163.027L251.705 167.086Z",
    fill: "#6792FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 68_3",
    cx: 291.772,
    cy: 196.162,
    rx: 5.77004,
    ry: 6.71664,
    fill: "#88A9FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3",
    d: "M369.832 142.008L262.95 204.242V230.089L369.832 169.213V142.008Z",
    fill: "#65813F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 72",
    d: "M98.8287 96.8145L301.28 206.467L270.963 209.987L80.8809 107.464L98.8287 96.8145Z",
    fill: "#65813F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Abdeckung",
    d: "M180.556 35.4961L383.007 145.149L270.963 209.987L80.8809 107.464L180.556 35.4961Z",
    fill: "#65813F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M85.6925 115.911C94.7827 122.652 94.7827 133.773 85.6925 140.804C75.4531 147.688 63.339 147.688 53.1014 140.804C44.0131 134.066 44.0131 122.942 53.1014 115.911C63.339 109.027 75.4531 109.027 85.6925 115.911Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M63.8948 88.7356C78.4827 88.7356 90.3091 101.548 90.3091 117.351C90.3091 133.154 78.4827 145.967 63.8948 145.967C49.3059 145.967 36.3799 132.054 36.3799 116.25C36.3799 100.447 49.3059 88.7356 63.8948 88.7356Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M79.1137 110.962C70.0976 116.52 55.4902 116.52 46.4741 110.962C42.3651 108.492 40.1967 105.157 39.7403 101.944C39.2828 106.022 41.4522 110.096 46.4741 113.184C55.4902 118.742 70.0976 118.742 79.1137 113.184C84.0227 110.096 86.305 106.02 85.8486 101.944C85.3911 105.279 83.2247 108.486 79.1137 110.962Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M82.5478 130.771C72.2437 136.33 55.5495 136.33 45.2454 130.771C40.5494 128.301 38.0712 124.967 37.5496 121.754C37.0268 125.831 39.506 129.906 45.2454 132.994C55.5495 138.552 72.2437 138.552 82.5478 132.994C88.1581 129.906 90.7664 125.829 90.2447 121.754C89.722 125.089 87.246 128.296 82.5478 130.771Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M105.224 134.551C111.318 139.07 111.318 146.525 105.224 151.238C98.3602 155.853 90.2395 155.853 83.3769 151.238C77.2845 146.721 77.2845 139.264 83.3769 134.551C90.2395 129.936 98.3602 129.936 105.224 134.551Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M90.6124 116.335C100.391 116.335 108.319 124.923 108.319 135.517C108.319 146.111 100.391 154.699 90.6124 154.699C80.8328 154.699 72.168 145.373 72.168 134.779C72.168 124.186 80.8328 116.335 90.6124 116.335Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M100.815 131.234C94.7707 134.96 84.9787 134.96 78.9348 131.234C76.1803 129.578 74.7268 127.343 74.4208 125.189C74.1142 127.923 75.5684 130.654 78.9348 132.724C84.9787 136.45 94.7707 136.45 100.815 132.724C104.105 130.654 105.635 127.921 105.329 125.189C105.023 127.425 103.57 129.575 100.815 131.234Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M103.116 144.513C96.2084 148.239 85.0176 148.239 78.1103 144.513C74.9623 142.857 73.3011 140.622 72.9514 138.468C72.601 141.201 74.2629 143.933 78.1103 146.003C85.0176 149.729 96.2084 149.729 103.116 146.003C106.877 143.933 108.625 141.2 108.275 138.468C107.925 140.704 106.265 142.854 103.116 144.513Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M417.816 130.123C427.049 133.932 427.049 140.218 417.816 144.191C407.416 148.082 395.112 148.082 384.713 144.191C375.482 140.383 375.482 134.096 384.713 130.123C395.112 126.232 407.416 126.232 417.816 130.123Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M400.751 136.877L395.828 107.295C395.946 108.502 395.344 109.422 394.022 110.253C391.517 111.828 387.366 112.046 384.75 110.663C383.39 109.946 382.715 109 382.729 108.009L382.726 108.009L379.759 138.876C379.604 140.617 380.705 142.334 383.047 143.572C387.32 145.83 394.102 145.543 398.194 142.97C400.927 141.251 401.765 138.9 400.751 136.877Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M378.029 51.3022C391.717 51.3022 402.814 62.7461 402.814 76.8615C402.814 90.9769 391.717 102.421 378.029 102.421C364.341 102.421 353.245 90.9769 353.245 76.8615C353.245 62.7461 364.341 51.3022 378.029 51.3022Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M392.022 70.9468C383.864 75.4171 370.647 75.4171 362.489 70.9468C358.772 68.9603 356.81 66.2783 356.397 63.6946C355.983 66.9738 357.946 70.2505 362.489 72.7342C370.647 77.2045 383.864 77.2045 392.022 72.7342C396.463 70.2505 398.528 66.9721 398.115 63.6946C397.701 66.3766 395.741 68.9561 392.022 70.9468Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M394.209 88.8929C384.843 93.9219 369.668 93.9219 360.302 88.8929C356.033 86.6581 353.781 83.6408 353.307 80.7341C352.831 84.4232 355.085 88.1095 360.302 90.9037C369.668 95.9328 384.843 95.9328 394.209 90.9037C399.309 88.1095 401.68 84.4213 401.206 80.7341C400.73 83.7514 398.48 86.6533 394.209 88.8929Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M399.716 63.6946C413.404 63.6946 424.501 75.1384 424.501 89.2538C424.501 103.369 413.404 114.813 399.716 114.813C386.027 114.813 374.931 103.369 374.931 89.2538C374.931 75.1384 386.027 63.6946 399.716 63.6946Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M415.03 83.3391C406.57 87.8094 392.864 87.8094 384.404 83.3391C380.549 81.3526 378.514 78.6706 378.086 76.0869C377.657 79.3661 379.692 82.6428 384.404 85.1266C392.864 89.5968 406.57 89.5968 415.03 85.1266C419.636 82.6428 421.778 79.3644 421.349 76.0869C420.92 78.7689 418.887 81.3484 415.03 83.3391Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M417.445 101.285C408.078 106.314 392.904 106.314 383.537 101.285C379.269 99.0504 377.016 96.0331 376.542 93.1265C376.067 96.8156 378.32 100.502 383.537 103.296C392.904 108.325 408.078 108.325 417.445 103.296C422.544 100.502 424.915 96.8137 424.441 93.1265C423.966 96.1437 421.715 99.0457 417.445 101.285Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M378.03 85.3811C387.44 85.3811 395.069 93.3571 395.069 103.195C395.069 113.033 387.44 121.009 378.03 121.009C368.619 121.009 360.99 113.033 360.99 103.195C360.99 93.3571 368.619 85.3811 378.03 85.3811Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M387.646 100.115C381.905 103.467 372.605 103.467 366.864 100.115C364.248 98.6248 362.867 96.6133 362.577 94.6755C362.285 97.1349 363.667 99.5925 366.864 101.455C372.605 104.808 381.905 104.808 387.646 101.455C390.772 99.5925 392.225 97.1337 391.934 94.6755C391.643 96.687 390.263 98.6217 387.646 100.115Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M390.062 112.507C383.415 115.86 372.646 115.86 365.999 112.507C362.969 111.017 361.371 109.006 361.034 107.068C360.697 109.527 362.296 111.985 365.999 113.848C372.646 117.2 383.415 117.2 390.062 113.848C393.681 111.985 395.364 109.526 395.027 107.068C394.69 109.079 393.093 111.014 390.062 112.507Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stecker"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M433.987 140.556L454.038 158.841L437.488 167.889L411.719 171.756L410.125 154.318L433.987 140.556Z",
    fill: "#D8D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M410.125 173.452L437.706 178.039L437.487 167.889L410.125 154.318V173.452Z",
    fill: "#B5B3AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M454.036 168.633V158.841L437.485 167.889L437.707 178.04L454.036 168.633Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M448.612 162.682C443.73 161.855 437.773 172.157 442.82 174.764L450.805 178.321L456.68 167.883L448.612 162.682Z",
    fill: "#D8D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M450.695 170.914C448.753 173.627 448.546 176.805 450.234 178.014C451.922 179.222 454.865 178.004 456.808 175.291C458.75 172.58 458.957 169.401 457.269 168.191C455.58 166.983 452.638 168.202 450.695 170.914Z",
    fill: "#8D8A83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lupe_mit_Schatten"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.114 98.4211L192.115 98.3949L192.116 98.3687L192.144 97.3681L192.168 97.3684C193.602 78.0355 220.047 62.8236 252.002 63.1944C283.968 63.5653 309.549 79.3903 309.884 98.7518L309.907 98.752L309.548 111.548L309.546 111.629L309.544 111.702C309.543 111.754 309.541 111.805 309.539 111.856L309.535 112.027L309.533 112.027C308.676 133.066 281.94 149.766 249.587 149.391C233.4 149.203 218.857 144.776 208.406 137.763L201.892 141.771L201.883 141.754C201.467 141.98 200.844 142.296 200.067 142.69L200.066 142.69L200.066 142.69C199.7 142.876 199.301 143.078 198.872 143.297C198.887 143.573 198.891 143.843 198.884 144.108C198.882 144.168 198.881 144.23 198.879 144.293C198.835 146.113 198.76 149.181 193.361 152.283L193.362 152.285L193.288 152.329C193.191 152.395 193.09 152.456 192.987 152.513L191.732 153.252L191.42 153.438C191.381 153.462 191.341 153.485 191.301 153.508L155.244 174.91C155.204 174.935 155.163 174.96 155.121 174.983L151.156 177.337C151.079 177.387 151 177.434 150.919 177.478C147.854 179.152 143.243 176.012 140.619 170.466C137.995 164.92 138.353 159.067 141.417 157.394C141.441 157.381 141.465 157.368 141.49 157.356L143.954 155.891C143.936 155.9 143.919 155.909 143.901 155.919C144.03 155.846 144.322 155.658 144.641 155.452C144.953 155.252 145.289 155.035 145.522 154.894C145.676 154.811 145.833 154.739 145.993 154.679L182.395 133.042C182.49 132.983 182.591 132.92 182.693 132.856L182.693 132.856C182.962 132.688 183.238 132.516 183.44 132.395C183.527 132.347 183.616 132.303 183.706 132.263L185.522 131.184L185.528 131.199C188.421 129.603 191.331 130.564 193.693 132.695L196.829 130.92L196.837 130.935L199.074 129.558C194.323 123.952 191.665 117.495 191.774 110.643L191.772 110.643L192.114 98.4211ZM143.901 155.919L143.885 155.927C143.877 155.932 143.87 155.935 143.864 155.939L143.901 155.919Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lupe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hauptteil"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 533",
    x: 175.257,
    y: 74.969,
    width: 4.51859,
    height: 15.9437,
    transform: "rotate(1.11744 175.257 74.969)",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 534",
    x: 301.837,
    y: 77.459,
    width: 4.51859,
    height: 15.9437,
    transform: "rotate(1.11744 301.837 77.459)",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 52",
    d: "M238.515 37.205C203.695 36.0798 185.942 60.8945 181.418 73.4425C187.582 65.3492 207.585 49.1487 238.283 49.0933C276.655 49.0242 297.942 73.1137 298.029 68.6556C298.116 64.1974 282.039 38.6114 238.515 37.205Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.604 137.897C275.806 138.603 305.555 118.546 306.052 93.0976C306.548 67.6495 277.603 46.4473 241.402 45.7412C205.2 45.0351 175.45 65.0924 174.954 90.5405C174.457 115.989 203.402 137.191 239.604 137.897ZM239.85 125.294C271.305 125.908 297.131 109.643 297.534 88.9655C297.938 68.288 272.765 51.0283 241.311 50.4147C209.856 49.8012 184.03 66.0662 183.626 86.7437C183.223 107.421 208.395 124.681 239.85 125.294Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 105",
    cx: 240.715,
    cy: 80.9385,
    rx: 56.9648,
    ry: 37.447,
    transform: "rotate(1.11744 240.715 80.9385)",
    fill: "#DEEFFF",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 106",
    d: "M272.842 98.0378C272.741 103.224 258.105 107.145 240.152 106.795C222.199 106.444 207.727 101.956 207.828 96.7696C207.871 94.5727 222.372 97.5575 240.325 97.9076C258.278 98.2578 272.893 95.4289 272.842 98.0378Z",
    fill: "white",
    fillOpacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 51",
    d: "M238.076 118.031C206.756 117.42 186.079 101.036 182.78 95.2109C193.442 123.479 211.246 127.171 237.855 129.362C259.142 131.116 284.836 114.607 295.023 106.134L292.041 100.687C287.103 106.723 269.395 118.642 238.076 118.031Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.942 120.57C276.144 121.277 305.867 102.557 306.331 78.759C306.795 54.961 277.824 35.0965 241.623 34.3904C205.421 33.6842 175.697 52.4039 175.233 76.2018C174.769 99.9998 203.74 119.864 239.942 120.57ZM240.052 114.92C271.507 115.534 297.333 99.2688 297.736 78.5914C298.14 57.9139 272.968 40.6541 241.513 40.0406C210.058 39.427 184.232 55.6921 183.828 76.3695C183.425 97.047 208.597 114.307 240.052 114.92Z",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 50",
    d: "M184.007 130.34C183.849 124.905 180.272 119.119 178.527 117.477L182.838 115.305L188.039 128.487C187.577 128.769 186.084 129.409 184.007 130.34Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 106_2",
    d: "M183.983 131.298C183.73 133.878 183.569 138.878 172.352 142.517C166.884 144.29 159.815 135.845 160.626 127.565C161.437 119.284 164.195 120.518 168.82 115.476C177.195 109.162 184.794 123.018 183.983 131.298Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 535",
    width: 11.4779,
    height: 14.1405,
    transform: "matrix(0.875135 -0.483878 0.377229 0.92612 182.186 115.688)",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 536",
    d: "M118.923 141.877L170.274 114.55L177.155 140.571L127.916 166.734L118.923 141.877Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 107",
    rx: 7.12665,
    ry: 13.2346,
    transform: "matrix(0.900154 -0.435572 0.332878 0.94297 123.507 154.257)",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M134.69 148.546C137.123 155.438 136.271 162.46 132.728 164.175L130.951 165.112C130.872 165.157 130.792 165.199 130.711 165.239L130.951 165.112C134.292 163.201 135.065 156.334 132.688 149.6C130.265 142.736 125.522 138.584 121.984 140.244C121.967 140.252 121.952 140.259 121.941 140.264C121.955 140.257 121.969 140.25 121.984 140.244C122.277 140.096 123.323 139.465 123.869 139.17C127.412 137.456 132.257 141.653 134.69 148.546Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M178.681 125.18C181.114 132.072 180.262 139.094 176.719 140.809L174.942 141.746C174.863 141.791 174.783 141.833 174.701 141.873L174.942 141.746C178.283 139.835 179.056 132.969 176.679 126.235C174.258 119.377 169.551 115.179 166.014 116.825C165.993 116.836 165.975 116.844 165.961 116.851C165.978 116.842 165.996 116.833 166.014 116.825C166.319 116.674 167.32 116.096 167.86 115.804C171.403 114.09 176.248 118.287 178.681 125.18Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 109",
    rx: 5.44089,
    ry: 10.104,
    transform: "matrix(0.900154 -0.435572 0.332878 0.94297 122.705 154.207)",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 110",
    rx: 4.71679,
    ry: 10.104,
    transform: "matrix(0.900154 -0.435572 0.332878 0.94297 123.357 153.892)",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 108",
    rx: 3.83212,
    ry: 7.11646,
    transform: "matrix(0.900154 -0.435572 0.332878 0.94297 194.861 116.711)",
    fill: "#787878"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fragezeichen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.459 53.0858L254.641 51.0734L254.641 51.1478C254.617 51.1152 254.593 51.0827 254.569 51.0503L252.012 54.2384C252.944 55.2432 253.777 56.3245 254.496 57.4596C255.275 58.683 255.936 59.9516 256.47 61.2435C257.017 62.5396 257.396 63.8561 257.598 65.1565C257.781 66.3251 257.771 67.4623 257.567 68.5231C257.391 69.4719 256.981 70.3065 256.367 70.9646C256.009 71.3648 255.538 71.6504 254.988 71.7999C254.491 71.9219 253.946 71.934 253.384 71.8355C252.81 71.7309 252.232 71.5709 251.658 71.3579L249.99 70.7272C249.258 70.4248 248.512 70.2641 247.798 70.2552C247.131 70.2797 246.52 70.4593 246.011 70.7808C245.241 71.2905 244.545 71.8881 243.931 72.5654L245.59 76.5651L241.42 74.7121L241.465 74.9668L241.349 74.6873L238.272 77.8837L240.668 83.7054L242.765 81.5277L241.658 86.0166L250.966 84.7115L246.921 77.8728L250.859 79.5175L250.854 79.4992L250.861 79.5163C251.765 78.5703 252.525 78.0445 253.143 77.939C253.761 77.8335 254.818 78.0752 256.315 78.664C257.454 79.0928 258.602 79.4142 259.743 79.6232C260.58 79.7788 261.389 79.7481 262.11 79.5332C262.819 79.2748 263.432 78.8668 263.917 78.3308C264.952 77.1948 265.639 75.7607 265.927 74.1349C266.297 72.2498 266.329 70.2292 266.02 68.1509C265.716 65.9588 265.1 63.7336 264.188 61.5419C263.564 60.0222 262.841 58.5192 262.022 57.0444C261.268 55.6901 260.415 54.3706 259.471 53.0997L259.474 53.0924L259.462 53.0872L259.46 53.0844L259.459 53.0858Z",
    fill: "#C3337F",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M231.257 22.7402C233.385 23.2098 235.471 23.8564 237.491 24.6735C239.68 25.563 241.803 26.6073 243.844 27.7985C246.799 29.4999 249.498 31.6129 251.858 34.074C254.117 36.381 255.989 39.0371 257.402 41.9401C258.651 44.4053 259.33 47.12 259.387 49.883C259.417 51.1817 259.202 52.4746 258.752 53.6933C258.25 54.871 257.487 55.92 256.523 56.762C255.21 57.9141 253.784 58.9303 252.267 59.7949C250.249 60.8997 248.987 61.9055 248.483 62.8125C247.978 63.7195 247.729 65.3493 247.736 67.702L241.113 63.8763C241.075 62.2339 241.193 60.5916 241.465 58.9715C241.661 57.92 242.089 56.9256 242.718 56.0613C243.425 55.1823 244.306 54.4596 245.306 53.9388L247.531 52.6755C248.293 52.236 249.009 51.722 249.669 51.1412C250.311 50.5678 250.833 49.8724 251.203 49.0954C251.6 48.2157 251.793 47.2574 251.766 46.2926C251.747 44.6746 251.362 43.0818 250.641 41.6333C249.841 40.0059 248.78 38.5202 247.501 37.2348C246.079 35.8019 244.468 34.5699 242.713 33.5728C240.975 32.5649 239.134 31.747 237.22 31.1332C235.449 30.5594 233.615 30.1989 231.758 30.0591L231.257 22.7402ZM248.411 74.3969V82.3755L240.586 77.8236V69.845L248.411 74.3969Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 352",
    d: "M224.651 26.1457L231.278 22.7332L233.14 29.3506L227.855 30.5287L224.651 26.1457Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 353",
    d: "M238.313 68.3079L242.35 63.8095L247.735 67.7059L241.128 71.1096L238.313 68.3079Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 354",
    d: "M233.979 73.2551L241.038 69.8596L243.879 72.638L240.479 79.5459L233.979 73.2551Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 355",
    d: "M238.859 81.3138L241.13 76.7249L248.418 82.3623L241.805 85.7839L238.859 81.3138Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 53",
    d: "M252.355 37.7926C250.551 33.3556 238.556 28.9998 232.785 27.3765L232.244 31.9758L240.18 35.7184L250.145 49.6968L253.031 48.8852C253.557 47.0364 254.158 42.2296 252.355 37.7926Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M224.558 26.2068C226.686 26.6763 228.772 27.323 230.792 28.1401C232.981 29.0296 235.104 30.0739 237.144 31.265C240.1 32.9665 242.798 35.0794 245.159 37.5406C247.418 39.8475 249.29 42.5037 250.703 45.4067C251.952 47.8718 252.63 50.5865 252.687 53.3495C252.718 54.6483 252.503 55.9411 252.053 57.1599C251.55 58.3376 250.788 59.3866 249.823 60.2286C248.511 61.3807 247.085 62.3968 245.568 63.2615C243.55 64.3662 242.288 65.3721 241.783 66.279C241.279 67.186 241.03 68.8158 241.037 71.1685L234.413 67.3429C234.375 65.7004 234.494 64.0581 234.766 62.438C234.961 61.3866 235.389 60.3922 236.019 59.5279C236.726 58.6489 237.607 57.9261 238.607 57.4054L240.832 56.1421C241.594 55.7026 242.31 55.1886 242.97 54.6077C243.612 54.0344 244.134 53.3389 244.504 52.5619C244.901 51.6822 245.094 50.7239 245.067 49.7592C245.048 48.1411 244.663 46.5483 243.942 45.0998C243.141 43.4725 242.081 41.9867 240.801 40.7013C239.38 39.2685 237.769 38.0364 236.014 37.0393C234.276 36.0315 232.434 35.2136 230.521 34.5997C228.75 34.026 226.916 33.6654 225.059 33.5257L224.558 26.2068ZM241.712 77.8634V85.8421L233.886 81.2902V73.3115L241.712 77.8634Z",
    fill: "#C3337F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetzauskunft);
export default __webpack_public_path__ + "static/media/Netzauskunft.53028d906d08a49c2a3e980f9cf9e641.svg";
export { ForwardRef as ReactComponent };